import {
  DELETE_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE,
  GET_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE,
  GET_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE_AVAILABLE_ITEMS,
  GET_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE_LIST,
  POST_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE,
  PUT_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE,
} from "../constants/actionTypes";

const defaultState = {
  expenseAccountFullyDeductibleArr: [],
  expenseAccountFullyDeductible: {},
  availableItems: [],
};
let data = [];
export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE_LIST:
        return {
          ...state,
          expenseAccountFullyDeductibleArr: [...(action.payload || [])],
        };
      case GET_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE:
        return { ...state, expenseAccountFullyDeductible: { ...action.payload } };
      case GET_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE_AVAILABLE_ITEMS:
        return { ...state, availableItems: [...(action.payload || [])] };
      case POST_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE:
        return {
          ...state,
          expenseAccountFullyDeductibleArr: [
            ...state?.expenseAccountFullyDeductibleArr,
            action.payload,
          ],
        };
      case PUT_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE:
        data = [...state?.expenseAccountFullyDeductibleArr];
        {
          const index = data?.findIndex(
            (setting) => setting?.id === action.payload?.id,
          );
          if (index !== -1) data[index] = { ...action?.payload };
        }
        return {
          ...state,
          expenseAccountFullyDeductibleArr: [...data],
          expenseAccountFullyDeductible: { ...action.payload },
        };
      case DELETE_EXPENSE_ACCOUNT_FULLY_DEDUCTIBLE:
        data = [...state?.expenseAccountFullyDeductibleArr];
        {
          const newData = data?.filter((income) => income.id !== action.payload);
          return {
            ...state,
            expenseAccountFullyDeductibleArr: [...newData],
          };
        }
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
